<template>
  <div class="alert-labels" v-if="labelsFilter.length > 0" :class="{ 'alert-labels-padding': hasPadding }">
    <div
      class="alert-labels-content"
      :class="{ 'alert-labels-warn': labelType.hasWarn, 'alert-labels-error': labelType.hasError }"
      @click="handleClick"
    >
      <simple-space :direction="'vertical'" :size="[0]">
        <div v-for="(label, index) in labelsFilter" class="alert-label" :key="index">
          <span
            :class="{
              'alert-label-info': label.level === 'INFO',
              'alert-label-warn': label.level === 'WARN',
              'alert-label-error': label.level === 'ERROR',
            }"
          >
            <span> {{ label.name }}</span>
            <span v-if="label.toast"> :</span>
          </span>
          <label-toast :toast="label.toast" />
        </div>
      </simple-space>
      <div class="alert-labels-arrow">
        <img class="alert-labels-arrow-icon" :src="rightArrow" alt="arrow" />
      </div>
    </div>
    <alert-labels-modal
      v-model="showDetailPopup"
      :labels="labelsFilter"
      :submitedDate="submitedDate"
      :invoiceExcessReason="invoiceExcessReason"
    />
  </div>
</template>

<script>
import SimpleSpace from 'components/business/expense-list/detail/simple-space';
import rightArrow from 'assets/images/application/travel/arrow-right@3x.png';
import LabelToast from 'components/business/label/alert-labels/label-toast';
import AlertLabelsModal from 'components/business/label/alert-labels/alert-labels-modal';
import { NativeService } from 'service/native/nativePluginService';

export default {
  name: 'alert-labels',
  data() {
    return {
      rightArrow,
      showDetailPopup: false,
    };
  },
  props: {
    labels: {
      type: Array,
    },
    compression: {
      type: Boolean,
    },
    entityType: {
      type: Number,
    },
    hasPadding: {
      type: Boolean,
    },
    submitedDate: {
      type: String,
    },
    invoiceExcessReason: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {
    labelType() {
      const types = {};
      this.labels.forEach((l) => {
        if (l.level === 'ERROR') types.hasError = true;
        if (l.level === 'WARN') types.hasWarn = true;
      });
      return types;
    },
    labelsFilter() {
      if (this.compression) return this.labels.filter((l) => l.level !== 'INFO');
      return this.labels;
    },
  },
  methods: {
    handleClick() {
      this.showDetailPopup = true;
      NativeService().setTitle(window.$t('expense-2.key198', { cm: '检查结果' }), false);
    },
  },
  components: { AlertLabelsModal, LabelToast, SimpleSpace },
};
</script>

<style scoped lang="scss">
.alert-labels {
  background: #f9f9f9;
  &-padding {
    padding: px(20) px(30) px(0) px(30);
  }
  &-content {
    padding: 12px 16px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 24px;
    color: #252629;
  }
  .simple-space {
    width: 90%;
  }
  &-arrow {
    width: 10%;
    text-align: right;
    &-icon {
      width: 24px;
    }
  }
  &-warn {
    background: #fffaf0;
  }
  &-error {
    background: #fff3f0;
  }
  .alert-label {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
    color: #71757e;
    &-info {
      color: #252629;
    }
    &-warn {
      color: #ff800b;
    }
    &-error {
      color: #f04134;
    }
  }
}
</style>
